<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <el-input placeholder="请输入内容" v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="主题ID" :value="1"></el-option>
                            <el-option label="主题名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/theme/manger/list')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button v-if="$utils.have('/theme/manger/list')" type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="ID" prop="id"></el-table-column>
                <el-table-column label="名称"  min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis" :href="scope.row.siteLink" target="_blank">{{ scope.row.nameStr || scope.row.name }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="绑定演出数" prop="bindActivityCounts"></el-table-column>                
                <el-table-column label="创建时间" prop="createTime" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/theme/manger/detail')"
                            icon="el-icon-s-management"
                            @click="toManage(scope.row.id)"
                            >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    type: 1,
    value: ''
}
export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || ""
            },
            listLoading: true
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/theme/manger/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        const data = result.result || [];
                        if(data.length){
                            data.forEach(item=> {
                                item.siteLink = `${process.env.VUE_APP_SSWAP_URL}/pages/activity/list/list?type=2&tag=${item.id}`
                                if(item.name && item.name.length>40){
                                    item.nameStr = item.name.slice(0,40) + '...'
                                }                                
                            })
                        }
                        this.dataList = data;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {...defaultParams,pageSize: this.params.pageSize}
            this.getDataList();
        },
        toManage(id){
            this.$router.push({
                name: 'theme-manage', 
                params: {id},
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
            // this.$router.push({name: 'theme-manage', params: {id}})
        }
    }
};
</script>
